import {CalendarSlot} from "../../entities/CalendarSlot";
import {IVanCalendar} from "./IVanCalendar";
import {Van} from "../../../../../server/src/base/entities/leasing/Van";
import {ICurrentVan} from "./ICurrentVan";
import {Slot} from "../../../../../server/src/base/entities/leasing/calendar/Slot";
import {CalendarDaySlot} from "../../entities/CalendarDaySlot";

export class UnavailabilityVanCalendar extends IVanCalendar{

    private vanCalendar:IVanCalendar;
    private currentVan:ICurrentVan;
    private isUnavailabilityView:boolean;

    constructor(userCalendar: IVanCalendar, currentVan: ICurrentVan, isUnavailabilityView:boolean) {
        super();
        this.vanCalendar = userCalendar;
        this.currentVan = currentVan;
        this.isUnavailabilityView = isUnavailabilityView;
        this.InnerUpdate();
    }

    public Update(van: Van) {
        this.vanCalendar.Update(van);
        this.InnerUpdate();
    }

    private InnerUpdate(){
        for(let slot of this.vanCalendar.Slots()){
            this.CheckSlotUnavailable(slot);
        }
    }

    private CheckSlotUnavailable(slot:CalendarSlot){
        for(let removedSlot of this.currentVan.Value().unavailability.removedSlots.Value()){
            let amDate:Date = new Date(this.CurrentMonth().getFullYear(), this.CurrentMonth().getMonth(), slot.Day(), 1);
            if(amDate.getTime() == removedSlot.slot.Date().getTime()){
                if(this.isUnavailabilityView){
                    slot.DaySlots()[0].Free();
                }else{
                    slot.DaySlots()[0].Taken();
                }
            }
            let pmDate:Date = new Date(this.CurrentMonth().getFullYear(), this.CurrentMonth().getMonth(), slot.Day(), 13);
            if(pmDate.getTime() == removedSlot.slot.Date().getTime()){
                if(this.isUnavailabilityView){
                    slot.DaySlots()[1].Free();
                }else{
                    slot.DaySlots()[1].Taken();
                }
            }
        }
    }

    public NextMonth() {
        this.vanCalendar.NextMonth();
        this.InnerUpdate();
    }

    public PreviousMonth() {
        this.vanCalendar.PreviousMonth();
        this.InnerUpdate();
    }

    public CurrentMonth(): Date {
        return this.vanCalendar.CurrentMonth();
    }

    public FirstDayOfTheMonth(): number {
        return this.vanCalendar.FirstDayOfTheMonth();
    }

    public LastDayOfTheMonth(): number {
        return this.vanCalendar.LastDayOfTheMonth();
    }

    public Slots(): Array<CalendarSlot> {
        return this.vanCalendar.Slots();
    }

    CalendarSlot(slot: Slot): CalendarDaySlot {
        return this.vanCalendar.CalendarSlot(slot);
    }
}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/domain/leasing/UnavailabilityVanCalendar.ts